module.exports = __webpack_public_path__ + "assets/img/facebook.51dfb719.webp";